/**
 * Stranica za pokretanje eID OIDC login flow-a.
 */

import React, { useEffect, useState } from 'react';
import AuthService from '@/core/auth/AuthService';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import LoginLaunchErrorView from './LoginLaunchErrorView';
import './LoginLaunchPage.css';

const LoginLaunchPage = () => {
  useDocumentTitle('Пријава - Партнерство за отворену управу');

  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let active = true;

    AuthService.login().catch(() => {
      if (active) setHasError(true);
    });

    return () => {
      active = false;
    };
  }, []);

  if (hasError) {
    return <LoginLaunchErrorView />;
  }

  return (
    <section className="login-launch-page content-wrapper py-6" aria-labelledby="login-launch-title">
      <div className="login-launch-card" role="status" aria-live="polite">
        <div className="login-launch-spinner" aria-hidden="true" />
        <p className="login-launch-eyebrow">eUprava eID</p>
        <h1 id="login-launch-title" className="login-launch-title">Преусмеравање на пријаву...</h1>
        <p className="login-launch-message">
          Молимо сачекајте док вас систем безбедно преусмерава на страницу за пријаву.
        </p>
      </div>
    </section>
  );
};

export default LoginLaunchPage;
